import { Button, HStack } from '@chakra-ui/react'
import { Moon, Sun, SunMoon } from 'lucide-react'

export type BudgetShiftMode = 'Day' | 'Night' | 'Both'

interface BudgetKpiShiftToggleProps {
  value: BudgetShiftMode
  onChange: (mode: BudgetShiftMode) => void
}

export function BudgetKpiShiftToggle({ value, onChange }: BudgetKpiShiftToggleProps) {
  return (
    <HStack spacing={3} flexWrap="wrap">
      <Button
        size="sm"
        leftIcon={<Sun size={16} />}
        variant={value === 'Day' ? 'solid' : 'outline'}
        onClick={() => onChange('Day')}
      >
        Day Shift
      </Button>
      <Button
        size="sm"
        leftIcon={<Moon size={16} />}
        variant={value === 'Night' ? 'solid' : 'outline'}
        onClick={() => onChange('Night')}
      >
        Night Shift
      </Button>
    </HStack>
  )
}
